import { memo } from 'react';
import type { AdminFeedbackType, FeedbackSeverity, FeedbackStatus } from '../../types/feedback';
import { FEEDBACK_STATUSES } from '../../types/feedback';
import { FEEDBACK_STATUS_LABELS, FEEDBACK_TYPE_LABELS } from '../../utils/feedback-labels';
import { SEVERITY_LABELS } from '../../utils/severity-labels';

interface FeedbackFiltersProps {
  statusFilter: FeedbackStatus | undefined;
  typeFilter: AdminFeedbackType | undefined;
  severityFilter: FeedbackSeverity | undefined;
  onFilterChange: (key: string, value: string | undefined) => void;
  onClearFilters: () => void;
  hasActiveFilters: boolean;
}

export const FeedbackFilters = memo(function FeedbackFilters({
  statusFilter,
  typeFilter,
  severityFilter,
  onFilterChange,
  onClearFilters,
  hasActiveFilters,
}: FeedbackFiltersProps) {
  return (
    <div className="flex flex-wrap items-center gap-3">
      <div className="flex items-center gap-2">
        <label className="text-xs font-semibold uppercase tracking-wide text-text-grey">
          Status
        </label>
        <select
          value={statusFilter ?? ''}
          onChange={(e) => onFilterChange('status', e.target.value || undefined)}
          className="rounded-sm border border-black/10 bg-white px-3 py-1.5 text-sm text-brand-blue focus:border-brand-blue focus:outline-none"
        >
          <option value="">Alla</option>
          {FEEDBACK_STATUSES.map((value) => (
            <option key={value} value={value}>
              {FEEDBACK_STATUS_LABELS[value]}
            </option>
          ))}
        </select>
      </div>

      <div className="flex items-center gap-2">
        <label className="text-xs font-semibold uppercase tracking-wide text-text-grey">Typ</label>
        <select
          value={typeFilter ?? ''}
          onChange={(e) => onFilterChange('type', e.target.value || undefined)}
          className="rounded-sm border border-black/10 bg-white px-3 py-1.5 text-sm text-brand-blue focus:border-brand-blue focus:outline-none"
        >
          <option value="">Alla</option>
          {Object.entries(FEEDBACK_TYPE_LABELS).map(([value, label]) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </select>
      </div>

      <div className="flex items-center gap-2">
        <label className="text-xs font-semibold uppercase tracking-wide text-text-grey">
          Severity
        </label>
        <select
          value={severityFilter ?? ''}
          onChange={(e) => onFilterChange('severity', e.target.value || undefined)}
          className="rounded-sm border border-black/10 bg-white px-3 py-1.5 text-sm text-brand-blue focus:border-brand-blue focus:outline-none"
        >
          <option value="">Alla</option>
          {Object.entries(SEVERITY_LABELS).map(([value, label]) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </select>
      </div>

      {hasActiveFilters ? (
        <button
          type="button"
          onClick={onClearFilters}
          className="text-xs text-text-grey underline hover:text-brand-blue"
        >
          Rensa filter
        </button>
      ) : null}
    </div>
  );
});
